import React, { FC } from 'react'
import { Text, VStack, Button, Divider, Flex } from '@chakra-ui/react'
import { ITableFilterHeaderProps } from './types'
import { Checkbox, HeaderPopover, CellHeader, useColor, FlexDirection } from '@rw1/shared-lib'

export const TableFilterHeader: FC<ITableFilterHeaderProps> = ({
  filters,
  checkedItems,
  icon,
  onChangeFilter,
  children,
  getFilter,
}) => {
  const headerTextColor = useColor({ nuance: 6, palette: 'secondary' })
  const dividerColor = useColor({ nuance: 1, palette: 'secondary' })

  return (
    <HeaderPopover
      trigger={
        <Button
          _active={{ ring: 'none' }}
          _focus={{ ring: 'none' }}
          color={headerTextColor}
          fontSize="sm"
          fontWeight="medium"
          variant="unstyled">
          <CellHeader icon={icon}>{children}</CellHeader>
        </Button>
      }
      width="fit-content">
      <VStack alignItems="flex-start" padding={2}>
        {filters.map((filter) => (
          <Flex alignItems="flex-start" flexDirection={FlexDirection.Column} key={filter} w='full'>
            <Checkbox
              isChecked={checkedItems.includes(filter)}
              key={filter}
              onChange={(e) => onChangeFilter(filter, e.target.checked)}
              size='lg'
              spacing={4}>
              <Text
                fontSize="sm"
                fontWeight={500}
                lineHeight="16px"
              >
                {getFilter(filter)}
              </Text>
            </Checkbox>
            {filter === 'all' && <Divider border="1px" borderColor={dividerColor} marginBottom={1} marginTop={3} />}
          </Flex>
        ))}
      </VStack>
    </HeaderPopover>
  )
}
